<a #delayButton (click)="buttonClick()" style="margin-top: 0" class="button-like" [ngClass]="isButtonActive ? '' : 'button-like--disabled'">{{ defaultText | translate }}</a>
